import * as CookieConsent from 'vanilla-cookieconsent';

/**
 * Syncs consent categories TO the cookie banner library.
 *
 * **Context: Two-way consent flow**
 * There are two sources of consent truth that need to stay in sync:
 * 1. **App's localStorage** - stores GA4 consent keys (`ad_storage`, `analytics_storage`, etc.)
 * 2. **Cookie banner library** - manages its own internal state about accepted categories
 *
 * **When this function is called:**
 * - When host sends `sendConsent` message → we save to localStorage, then sync to banner
 * - When app loads with existing consent → we sync to banner to prevent it showing/hiding incorrectly
 *
 * **Why we need this:**
 * Without syncing, if consent already exists in localStorage:
 * - The banner might show when it shouldn't (because banner doesn't know about existing consent)
 * - The banner UI might show wrong checkboxes (banner thinks nothing is accepted, but we have consent)
 * - There could be a "flicker" where banner appears then disappears
 *
 * **The reverse flow (banner → app):**
 * When user interacts with banner → banner callbacks fire → `createConsentHandlers` →
 * `persistAndEmitConsentFromCookie` → saves to localStorage
 *
 * Uses the `acceptCategory` API method, passing an array of category names.
 * Note: `acceptCategory` also accepts a string (e.g., `'all'`) but this function
 * always passes an array since `categories` is always `Array<string>`.
 *
 * Reference: https://cookieconsent.orestbida.com/reference/api-reference.html#acceptcategory
 */
const syncConsentCategoriesToBanner = (categories: Array<string>): void =>
  CookieConsent.acceptCategory(categories);

export default syncConsentCategoriesToBanner;
